// Media Player: Audio
// 

JLM.MD.MediaPlayerAudio = function( container ) {
	
	const INSTANCE = new JLM.MD.MediaPlayer( container );
	
	
	// Variables: Private _______________________________________________________
	
	// Settings
	let time_duration;
	
	
	
	// Variables: Public ________________________________________________________
	
	INSTANCE.track_type = null;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// Get data
		INSTANCE.track_type = $('#jl_media_track_type', container).attr('content');
		
		// References
		const but_download = $('.jp-actions button.jp-download', container);
		
		// Events
		but_download.on('click', onDownloadTrack);
		
		// Build player
		INSTANCE.media.jPlayer({
			// Attributes
			cssSelectorAncestor: '#' + container.attr('id'),
			useStateClassSkin: true,
			swfPath: '/js/libraries',
			supplied: 'm4a',
			autoBlur: false,
			keyEnabled: true,
			remainingDuration: true,
			toggleDuration: true,
			
			// Events
			ready: function () {
				$(this).jPlayer('setMedia', { m4a: INSTANCE.src });
			},
			loadeddata: onLoad,
			play: onPlay,
			pause: onPause
		});
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Event: Media data has loaded
	// 
	function onLoad( event ) {
		INSTANCE.setDuration( event.jPlayer.status.duration );
	}
	
	
	// Event: Video played
	// 
	function onPlay() {
		$('.jp-title p').html( INSTANCE.description + ' – Playing' );
	}
	
	
	// Event: Video paused
	// 
	function onPause() {
		$('.jp-title p').html( INSTANCE.description + ' – Paused' );
	}
	
	
	// Event: Download track
	// 
	function onDownloadTrack() {
		window.location.href = '/download/audio/' + INSTANCE.talent_id + '/' + INSTANCE.track_type;
	}
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};